import React from 'react';
import { EMAIL_SLIDE, PLAN_LOADER_SLIDE, PROFILE_SLIDE_COMPONENT, QUESTION_ANSWER_SLIDE_COMPONENT, QUESTION_MULTI_ANSWER_SLIDE_COMPONENT, RISK_SLIDE, START_SLIDE, TRUST_SLIDE, USER_MIX_SUMMARY_SLIDE } from '../quiz-component-types';
import { QUIZ_RISK_SLIDES, RISK_QUESTION_IDS } from './quiz-risk-slides';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import fbImageSrc from '../../assets/images/answer/fb-new.png';
import instagramImageSrc from '../../assets/images/answer/instagram-new.png';
import youtubeImageSrc from '../../assets/images/answer/youtube-new.png';
import gmailImageSrc from '../../assets/images/answer/gmail-new.png';
import otherImageSrc from '../../assets/images/answer/other-socials.png';
import peopleImageSrc from '../../assets/images/slide/people-icon.png';
import dangerImageSrc from '../../assets/images/slide/danger-icon.png';
import lockImageSrc from '../../assets/images/slide/lock-icon.png';
import alertImageSrc from '../../assets/images/slide/alert-icon.png';
import warningImageSrc from '../../assets/images/slide/warning-icon.png';
import imprintImageSrc from '../../assets/images/slide/imprint-icon.png';
import cardImageSrc from '../../assets/images/slide/card-icon.png';
import robotImageSrc from '../../assets/images/slide/robot-icon.png';
import eyeImageSrc from '../../assets/images/slide/eye-icon.png';
import eyesImageSrc from '../../assets/images/slide/eyes-icon.png';
import searchImageSrc from '../../assets/images/slide/search-icon.png';

const QUIZ_SLIDES_V14 = [
    {
        id: 900,
        component: START_SLIDE,
        isNotIndexing: true
    },
    {
        id: 901,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        isNotBackButton: true,
        props: {
            question: <>How familiar are you with <br /> digital security tools?</>,
            answers: [
                {
                    text: 'Very familiar',
                    id: 4,
                    score: 0
                },
                {
                    text: 'Somewhat',
                    id: 5,
                    score: 1
                },
                {
                    text: 'Not familiar',
                    id: 6,
                    score: 2
                }
            ]
        }
    },
    {
        id: 9022,
        component: TRUST_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        }
    },
    {
        id: 902,
        component: QUESTION_MULTI_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'To start, tell us which online accounts do you use regularly?',
            answers: [
                {
                    text: 'Facebook',
                    imageUrl: fbImageSrc,
                    id: 1,
                    score: 0
                },
                {
                    text: 'Instagram',
                    imageUrl: instagramImageSrc,
                    id: 2,
                    score: 0
                },
                {
                    text: 'YouTube',
                    imageUrl: youtubeImageSrc,
                    id: 3,
                    score: 0
                },
                {
                    text: 'Gmail',
                    imageUrl: gmailImageSrc,
                    id: 4,
                    score: 0
                },
                {
                    text: 'Other',
                    imageUrl: otherImageSrc,
                    id: 5,
                    score: 0
                }
            ]
        },
        continueButton: {
            isVisible: true
        }
    },
    {
        id: 90222,
        component: USER_MIX_SUMMARY_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            description: 'To personalize your protection plan, tell us more about how you use the internet.',
            nextStepText: 'This will help us spot your biggest online risks.',
            prevQuestionId: 902
        }
    },
    {
        id: 903,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        isNotBackButton: true,
        props: {
            question: 'How often do you share your location online?',
            answers: [
                {
                    text: 'Never',
                    id: 4,
                    score: 0
                },
                {
                    text: 'Sometimes',
                    id: 5,
                    score: 1
                },
                {
                    text: 'Often',
                    id: 6,
                    score: 2
                }
            ]
        }
    },
    {
        id: 904,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'How many personal photos have you shared online?',
            answers: [
                {
                    text: 'Fewer than 50',
                    id: 1,
                    score: 0
                },
                {
                    text: '50-500',
                    id: 2,
                    score: 1
                },
                {
                    text: 'More than 500',
                    id: 3,
                    score: 2
                }
            ]
        }
    },
    {
        id: 905,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Do you post photos or videos of your family or home?',
            answers: [
                {
                    text: 'Never',
                    id: 4,
                    score: 0
                },
                {
                    text: 'Occasionally',
                    id: 5,
                    score: 1
                },
                {
                    text: 'Frequently',
                    id: 6,
                    score: 2
                }
            ]
        }
    },
    {
        id: 906,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Have you ever sent personal documents (ID, bills, contracts) by email?',
            answers: [
                {
                    text: 'No',
                    id: 1,
                    score: 0
                },
                {
                    text: 'Once or twice',
                    id: 2,
                    score: 1
                },
                {
                    text: 'Many times',
                    id: 3,
                    score: 2
                }
            ]
        }
    },
    {
        id: 907,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Do you reuse the same password on different accounts?',
            answers: [
                {
                    text: 'Never',
                    id: 4,
                    score: 0
                },
                {
                    text: 'On a few accounts',
                    id: 5,
                    score: 1
                },
                {
                    text: 'On most accounts',
                    id: 6,
                    score: 2
                }
            ]
        }
    },
    {
        id: 908,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'How often do you check your privacy settings on social media?',
            answers: [
                {
                    text: 'Regularly',
                    id: 1,
                    score: 0
                },
                {
                    text: 'Once or twice',
                    id: 2,
                    score: 1
                },
                {
                    text: 'Never',
                    id: 3,
                    score: 2
                }
            ]
        }
    },
    {
        id: 909,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Do you worry someone could use your photos or name online?',
            answers: [
                {
                    text: 'Never',
                    id: 4,
                    score: 0
                },
                {
                    text: 'Sometimes',
                    id: 5,
                    score: 1
                },
                {
                    text: 'Yes',
                    id: 6,
                    score: 2
                }
            ]
        }
    },
    ...QUIZ_RISK_SLIDES,
    {
        id: 90911,
        component: RISK_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            eventName: EVENT_TYPES.ONLINE_ACTIVITY_RISK_PAGE_VISITED,
            questionIds: [901, 903, 904, 905, 906, 907, 908, 909, ...RISK_QUESTION_IDS],
            maxRiskScore: 18,
            scoreThresholds: { low: 1, moderate: 5 },
            titlePrefix: 'Your online activity risk is',
            variants: {
                high: {
                    riskLabel: 'High',
                    riskIntro: 'You may be exposed to the following threats:',
                    riskItems: [
                        { id: 1, alt: 'people', text: <><strong>Fake accounts</strong> opened in your name</>, imageUrl: peopleImageSrc },
                        { id: 2, alt: 'lock', text: <><strong>Getting locked out</strong> of your real profiles</>, imageUrl: lockImageSrc },
                        { id: 3, alt: 'search', text: <><strong>Scammers getting a hold</strong> of your private details</>, imageUrl: searchImageSrc }
                    ],
                    nextStepText: <><strong>Now let's check if your data's been exposed.</strong></>
                },
                moderate: {
                    riskLabel: 'Moderate',
                    riskIntro: 'You may face the following safety gaps:',
                    riskItems: [
                        { id: 1, alt: 'alert', text: <>Targeted <strong>phishing and scam emails</strong></>, imageUrl: alertImageSrc },
                        { id: 2, alt: 'lock', text: <>Unexpected <strong>profile and account lockouts</strong></>, imageUrl: lockImageSrc },
                        { id: 3, alt: 'warning', text: <><strong>Private details shared</strong> without you knowing</>, imageUrl: warningImageSrc }
                    ],
                    nextStepText: <><strong>Now let's check if these gaps have been used against you.</strong></>
                },
                low: {
                    riskLabel: 'Low',
                    titleSuffix: ' — but not risk-free',
                    riskIntro: 'Scammers only need one open window to get in:',
                    riskItems: [
                        { id: 1, alt: 'warning', text: <>Tiny gaps that <strong>automated scam tools</strong> look for</>, imageUrl: warningImageSrc },
                        { id: 2, alt: 'imprint', text: <><strong>Hidden tracking</strong> of your daily online activity</>, imageUrl: imprintImageSrc },
                        { id: 3, alt: 'danger', text: <>Risks from <strong>older accounts</strong> left unchecked</>, imageUrl: dangerImageSrc }
                    ],
                    nextStepText: <><strong>One gap is enough. Let's check your exposure.</strong></>
                }
            }
        }
    },
    {
        id: 910,
        isNotBackButton: true,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Have you seen logins or devices you don\u2019t recognize on your accounts?',
            answers: [
                {
                    text: 'No',
                    id: 1,
                    score: 0
                },
                {
                    text: 'Maybe once',
                    id: 2,
                    score: 1
                },
                {
                    text: 'Yes, several times',
                    id: 3,
                    score: 2
                }
            ]
        }
    },
    {
        id: 911,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Have you received messages asking to confirm your password or login?',
            answers: [
                {
                    text: 'No',
                    id: 7,
                    score: 0
                },
                {
                    text: 'A few times',
                    id: 8,
                    score: 1
                },
                {
                    text: 'Often',
                    id: 9,
                    score: 2
                }
            ]
        }
    },
    {
        id: 912,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Have you noticed new connected accounts you didn\u2019t add yourself?',
            answers: [
                {
                    text: 'No',
                    id: 1,
                    score: 0
                },
                {
                    text: 'Not sure',
                    id: 2,
                    score: 1
                },
                {
                    text: 'Yes',
                    id: 3,
                    score: 2
                }
            ]
        }
    },
    {
        id: 913,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Have your friends ever said they got strange messages from you?',
            answers: [
                {
                    text: 'Never',
                    id: 4,
                    score: 0
                },
                {
                    text: 'Once or twice',
                    id: 5,
                    score: 1
                },
                {
                    text: 'Yes, more than once',
                    id: 6,
                    score: 2
                }
            ]
        }
    },
    {
        id: 914,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Have you seen alerts that your data or password was leaked?',
            answers: [
                {
                    text: 'No',
                    id: 1,
                    score: 0
                },
                {
                    text: 'Not sure',
                    id: 2,
                    score: 1
                },
                {
                    text: 'Yes, recently',
                    id: 3,
                    score: 2
                }
            ]
        }
    },
    {
        id: 915,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Do you keep photos of your ID, bills, or private info in your email or cloud?',
            answers: [
                {
                    text: 'No',
                    id: 4,
                    score: 0
                },
                {
                    text: 'Some',
                    id: 5,
                    score: 1
                },
                {
                    text: 'Many',
                    id: 6,
                    score: 2
                }
            ]
        }
    },
    {
        id: 916,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Have you started getting more spam calls or text messages lately?',
            answers: [
                {
                    text: 'No',
                    id: 4,
                    score: 0
                },
                {
                    text: 'A few',
                    id: 5,
                    score: 1
                },
                {
                    text: 'A lot',
                    id: 6,
                    score: 2
                }
            ]
        }
    },
    {
        id: 941,
        component: RISK_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            eventName: EVENT_TYPES.DATA_LEAK_RISK_PAGE_VISITED,
            questionIds: [910, 911, 912, 913, 914, 915, 916],
            maxRiskScore: 14,
            scoreThresholds: { low: 1, moderate: 5 },
            titlePrefix: 'Your data leak risk is',
            variants: {
                high: {
                    riskLabel: 'High',
                    riskIntro: 'You may be exposed to the following risks:',
                    riskItems: [
                        { id: 1, alt: 'lock', text: <>Passwords <strong>floating</strong> on the <strong>dark web</strong></>, imageUrl: lockImageSrc },
                        { id: 2, alt: 'card', text: <><strong>Identity theft</strong> and <strong>financial loss</strong></>, imageUrl: cardImageSrc },
                        { id: 3, alt: 'alert', text: <>Targeted <strong>scam messages</strong> in your inbox</>, imageUrl: alertImageSrc }
                    ],
                    nextStepText: <><strong>Now let's see your full risk profile.</strong></>
                },
                moderate: {
                    riskLabel: 'Moderate',
                    riskIntro: 'Your data may be exposed through these entry points:',
                    riskItems: [
                        { id: 1, alt: 'lock', text: <>Email or older passwords <strong>visible online</strong></>, imageUrl: lockImageSrc },
                        { id: 2, alt: 'robot', text: <>Increase in <strong>spam</strong> and <strong>automated robocalls</strong></>, imageUrl: robotImageSrc },
                        { id: 3, alt: 'eye', text: <><strong>Personal details</strong> sitting on <strong>public broker sites</strong></>, imageUrl: eyeImageSrc }
                    ],
                    nextStepText: <><strong>Now let's see your full risk profile.</strong></>
                },
                low: {
                    riskLabel: 'Low',
                    titleSuffix: ' — but not risk-free',
                    riskIntro: 'Even trusted companies can lose your data in silent leaks:',
                    riskItems: [
                        { id: 1, alt: 'warning', text: <><strong>Information caught</strong> in old company data leaks</>, imageUrl: warningImageSrc },
                        { id: 2, alt: 'eyes', text: <>Automated systems <strong>tracking your online name</strong></>, imageUrl: eyesImageSrc },
                        { id: 3, alt: 'danger', text: <>Inactive <strong>accounts left without protection</strong></>, imageUrl: dangerImageSrc }
                    ],
                    nextStepText: <><strong>Even a small leak can grow. Let's see your profile</strong></>
                }
            }
        }
    },
    {
        id: 942,
        component: PROFILE_SLIDE_COMPONENT,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            meters: [
                {
                    label: 'Online Activity Risk',
                    maxScore: 18,
                    questionIds: [901, 903, 904, 905, 906, 907, 908, 909, ...RISK_QUESTION_IDS],
                    scoreThresholds: { low: 1, moderate: 5 }
                },
                {
                    label: 'Data Leak Risk',
                    maxScore: 14,
                    questionIds: [910, 911, 912, 913, 914, 915, 916],
                    scoreThresholds: { low: 1, moderate: 5 }
                }
            ]
        }
    },
    {
        id: 944,
        component: PLAN_LOADER_SLIDE,
        isNotIndexing: true,
        props: {
            planTitle: 'Personal Digital Protection Plan',
            steps: ['Quiz responses collected', 'Matching your profile to threat patterns', 'Building your risk assessment'],
            hasRiskBadges: false,
            questions: {
                30: {
                    title: 'Protect Your Data',
                    description: 'Want to know how to protect your data right now?'
                },
                60: {
                    title: 'Check Identity Risks',
                    description: 'Want to check in real-time if your data has been leaked?'
                }
            }
        }
    },
    {
        id: 945,
        component: EMAIL_SLIDE,
        isNotIndexing: true,
        props: {
            planLabel: 'Protection Plan'
        }
    }
];

export {
    QUIZ_SLIDES_V14
};
